export default "__VITE_ASSET__BAeNzsZp__"